export default __webpack_public_path__ + "asset/serbia.d69010d59aa291c1e3b822f0ddef4260.svg";